if (!customElements.get('bundle-offer')) {
  customElements.define(
    'bundle-offer',
    class BundleOffer extends HTMLElement {
      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      onCartUpdate() {
        if (this.abortController) {
          this.abortController.abort();
        }
        this.abortController = new AbortController();
        const liveSection = this.dataset.liveSection || 'bundle-offer-live';
        fetch(`${this.dataset.sectionUrl}?section_id=${liveSection}`, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const source = html.querySelector('bundle-offer');
            if (source) {
              this.innerHTML = source.innerHTML;
            }
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              console.error(error);
            }
          });
      }
    }
  );
}
